import React, { useEffect, useState } from 'react'
import { url } from '../helpers/helpers'
import Table from '../components/table'
import { userContext } from '../context/user'
import Footer from '../components/Footer'
import PanelNav from '../components/PanelNav'
import PanelSidebar from '../components/PanelSidebar'

export default function Home() {
    const [allPartys, setAllPartys] = React.useState([])
    const [currentParty, setCurrentParty] = React.useState('')
    const [allTransporters, setAllTransporters] = React.useState([])
    const [currentTransporter, setCurrentTransporter] = React.useState('')
    const [eWayBill, setEwayBill] = React.useState("")
    const [orderThrough, setOrderThrough] = React.useState("")
    const [vehicleNo, setVehicleNo] = React.useState("")
    const [grn, setGrn] = React.useState("")
    const [currentHeaderId, setCurrentHeaderId] = React.useState(null)
    const [allItem, setAllItem] = React.useState([])
    const [currentItem, setCurrentItem] = React.useState("")
    const [boxes, setBoxes] = React.useState(0)
    const [weight, setWeight] = React.useState(0)
    const [billOfSupply, setBillOfSupply] = React.useState(true)
    const [interstate, setInterstate] = React.useState(false)
    const [intrastate, setIntrastate] = React.useState(false)
    const [grossAmt, setGrossAmt] = React.useState(0)
    const [totalWt, setTotalWt] = React.useState(0)
    const [totalbox, setTotalBox] = React.useState(0)
    const [middleItem, setMiddleItem] = React.useState([])
    const [discount, setDiscount] = React.useState(0)
    const [frieghtCharge, setFrieghtCharge] = React.useState(0)
    const [remarks, setRemarks] = React.useState('')
    const [tax, setTax] = React.useState()
    const [allGst, setAllGst] = React.useState([])
    const [allTaxAmt, setAllTaxAmt] = React.useState(0)
    const [loading, setLoading] = React.useState(false)
    const [uuid, setUuid] = React.useState('')
    const [invoiceNumber,setInvoiceNumber] = useState('')
    const [pastPurchase, setPastPurchase] = React.useState([])
    const [rateManual, setRateManual] = React.useState(0)
    const [driverName, setDriverName] = React.useState('');
    const [driverNumber, setDriverNumber] = React.useState('');
    const [loaders, setLoaders] = React.useState([])
    const [currentLoader, setCurrentLoader] = useState('')
    const [totalCostCompany,setTotalCostCompany] = useState(0)
    const [totalProfit,setTotalProfit] = useState(0)
    const [packedBy,setPackedBy] = useState('')
    const [usedBy,setUsedBy] = useState('')
    const [warranty,setWarranty] = useState('')

    const { user } = React.useContext(userContext)


    let partyName = ''
    let transporterName = ''
    let hsn = ""
    let rate = ""
    let totalWeight = 0
    let totalAmt = 0
    let taxAmount = 0
    let taxAmountMiddle = 0
    let finalAmount = 0
    let currentCategory = ""
    let cost_company_nettotal = 0
    let total_cost_company = 0
    let total_profit_item = 0

    React.useEffect(() => {
        setLoading(true)
        async function fetchBasics() {
            const response = await fetch(url + 'fetchData/')

            if (response.ok === true) {
                const data = await response.json()
                // console.log(response)
                setAllPartys(data.party_name)
                setAllTransporters(data.transporter)
                setAllItem(data.products)
                setAllGst(data.gst)
                setLoaders(data?.final_arr)
                setLoading(false)
            }
        }
        fetchBasics()
    }, [])


    const adjustValue = () => {
        if (currentParty) {
            let matchItem = allPartys.find(item => item.id == currentParty)
            partyName = matchItem.name
        }
        if (currentTransporter) {
            let transporter = allTransporters.find(item => item.id == currentTransporter)
            transporterName = transporter.name

        }
        if (currentItem.length > 0) {
            let selectedItem = allItem.find(item => item.id == currentItem.split('-')[0])
            hsn = selectedItem?.hsn
            rate = selectedItem?.rate
            cost_company_nettotal = selectedItem?.cost_company_nettotal ? parseFloat(selectedItem?.cost_company_nettotal).toFixed(2) : 0
        }
    }
    adjustValue()

    const calculateAmount = () => {
        if (boxes && weight && rateManual) {
            totalWeight = parseFloat(boxes) * parseFloat(weight)
            totalAmt = parseFloat(totalWeight) * parseFloat(rateManual)
            total_cost_company = parseFloat(totalWeight) * parseFloat(cost_company_nettotal)
            total_profit_item = totalAmt - total_cost_company
            if (tax) {
                taxAmountMiddle = ((parseFloat(totalAmt) / 100.0) * parseFloat(tax))
                totalAmt = parseFloat(totalAmt) + parseFloat(taxAmountMiddle)
            }
        }
    }
    calculateAmount()



    const handleSubmitOne = (e) => {
        e.preventDefault()
        if (currentParty && currentTransporter) {
            setLoading(true)
            const formData = new FormData()
            formData.append('client_id', currentParty)
            formData.append('transporter_id', currentTransporter)
            formData.append('eway', eWayBill)
            formData.append('orderThrough', orderThrough)
            formData.append('vehicle', vehicleNo)
            formData.append('grn', grn)
            formData.append("driver_name", driverName)
            formData.append("driver_number", driverNumber)
            formData.append("packed_by",packedBy)
            formData.append("used_by",usedBy)
            formData.append("warranty",warranty)

            async function sendData() {
                const response = await fetch(url + 'submitOne/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken,
                    },
                    body: formData
                })

                if (response.ok === true) {
                    const data = await response.json()
                    setPastPurchase(data.middle_list)
                    setCurrentHeaderId(data.header_id)
                    setUuid(data.uuid)
                    setInvoiceNumber(data?.invoiceNumber)
                    setLoading(false)
                }
            }
            sendData()

        } else {
            alert('Please Fill The Data Completely')
        }
    }


    const deleteEntry = (id) => {
        async function delteData() {
            setLoading(true)
            const response = await fetch(url + 'deleteItem/' + id + '/')

            if (response.ok == true) {
                const data = await response.json()
                setGrossAmt(parseFloat(data.totalAmt))
                setTotalWt(data.totalWt)
                setTotalBox(data.totalbox)
                setMiddleItem(data.result)
                setAllTaxAmt(data.totalTaxAmt)
                setLoading(false)
            }
        }
        delteData()
    }

    const handleSubmitTwo = e => {
        e.preventDefault()
        if (currentItem && boxes && weight && totalWeight && totalAmt) {
            setLoading(true)
            document.getElementById("mid-btn").disabled = true
            const formData = new FormData()
            formData.append("header_id", currentHeaderId)
            formData.append('currentItem', currentItem.split('-')[0])
            formData.append("boxes", boxes)
            formData.append("weight", weight)
            formData.append("totalWeight", totalWeight)
            formData.append('tax', tax)
            formData.append("totalAmt", totalAmt)
            formData.append("taxAmt", taxAmountMiddle)
            formData.append('rateManual', rateManual)
            formData.append("cost_company_nettotal",cost_company_nettotal)
            formData.append("total_cost_company",total_cost_company)
            formData.append("total_profit_item",total_profit_item)
            async function sendData() {
                const response = await fetch(url + 'submitMiddle/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken,
                    },
                    body: formData
                })

                if (response.ok == true) {
                    const data = await response.json()
                    console.log(data)
                    setGrossAmt(parseFloat(data.totalAmt))
                    setTotalWt(data.totalWt)
                    setTotalBox(data.totalbox)
                    setMiddleItem(data.result)
                    setAllTaxAmt(data.totalTaxAmt)
                    setTotalCostCompany(data?.totalCost)
                    setTotalProfit(data?.totalProfit)
                    setCurrentItem('')
                    setBoxes(0)
                    setWeight(0)
                    setTax('')
                    setRateManual(0)
                    hsn = ''
                    rate = 0
                    totalWeight = 0
                    totalAmt = 0
                    cost_company_nettotal = 0
                    total_cost_company = 0
                    total_profit_item = 0

                    document.getElementById("mid-btn").disabled = false
                    setLoading(false)
                }
            }
            sendData()
        } else {
            alert("Please Fill The Data")
        }
    }


    const handleSubmitThird = e => {
        e.preventDefault()
        if (currentHeaderId) {
            setLoading(true)
            setLoading(true)
            if (billOfSupply) {
                currentCategory = "bill of supply"
            }
            if (interstate) {
                currentCategory = "inter state"
            }
            if (intrastate) {
                currentCategory = "intra state"
            }
            const formData = new FormData()
            formData.append('header_id', currentHeaderId)
            formData.append('grossAmount', parseFloat(grossAmt) - parseFloat(allTaxAmt))
            formData.append("discount", discount)
            formData.append('taxAmt', allTaxAmt)
            formData.append('frieghtCharge', frieghtCharge)
            formData.append("finalAmount", finalAmount)
            formData.append("remarks", remarks)
            formData.append("category", currentCategory)
            formData.append('url', url)
            formData.append('totalCostCompany',totalCostCompany)
            formData.append('totalProfit',totalProfit)

            async function sendData() {
                const response = await fetch(url + 'submitThird/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken,
                    },
                    body: formData
                })

                if (response.ok == true) {
                    generatePDF(uuid,() => {
                        return window.location.reload()
                    })
                    
                }
            }
            sendData()
        } else {
            alert("Please Fill The Data")
        }
    }

    const adjustFinalAmount = () => {
        finalAmount = parseFloat(grossAmt) - parseFloat(discount)
        // taxAmount = parseFloat(finalAmount)/parseFloat(taxPercent)
        if (taxAmount == undefined || taxAmount == null || taxAmount == Infinity) {
            taxAmount = 0
        }
        finalAmount = parseFloat(taxAmount) + parseFloat(finalAmount) + parseFloat(frieghtCharge)
        finalAmount = Math.round(finalAmount)
        return
    }

    adjustFinalAmount()

    const savePrint = (cond) => {
        if (currentHeaderId) {
            setLoading(true)
            if (billOfSupply) {
                currentCategory = "bill of supply"
            }
            if (interstate) {
                currentCategory = "inter state"
            }
            if (intrastate) {
                currentCategory = "intra state"
            }
            const formData = new FormData()
            formData.append('header_id', currentHeaderId)
            formData.append('grossAmount', parseFloat(grossAmt) - parseFloat(allTaxAmt))
            formData.append("discount", discount)
            formData.append('taxAmt', allTaxAmt)
            formData.append('frieghtCharge', frieghtCharge)
            formData.append("finalAmount", finalAmount)
            formData.append("remarks", remarks)
            formData.append("category", currentCategory)
            formData.append('url', url)
            formData.append('totalCostCompany',totalCostCompany)
            formData.append('totalProfit',totalProfit)

            async function sendData() {
                const response = await fetch(url + 'submitThird/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken,
                    },
                    body: formData
                })

                if (response.ok == true) {
                    generatePDF(uuid,() => {
                        if (cond == 'bill') {
                            return window.location = window.location.origin + '/printBill/' + uuid + '/';
                        }
    
                        if (cond == 'challan') {
                            return window.location = window.location.origin + '/printChallan/' + uuid + '/';
                        }
                    })

                }
            }
            sendData()
        } else {
            alert("Please Fill The Data")
        }
    }

    async function generatePDF(uuid,action) {
        const formData1 = new FormData()
        formData1.append('uuid', uuid)
        const nextResponse = await fetch(url + 'printBillWp/', {
            method: 'POST',
            headers: {
                'X-CSRFToken': csrftoken,
            },
            body: formData1
        })

        if (nextResponse.ok == true) {
            const data = await nextResponse.json()

            const formData2 = new FormData()
            console.log(JSON.stringify(data?.data))
            formData2.append('data', JSON.stringify(data?.data))
            formData2.append('file_name', invoiceNumber)

            const response_laravel = await fetch('https://rlsl-laravel.webamplifierapps.com/api/fetch-pdf', {
                method: 'POST',
                // headers: {
                //     'Content-type': 'application/json'
                // },
                body: formData2
            })

            if (response_laravel.ok == true) {
                const data_laravel = await response_laravel.json()

                console.log(data_laravel)

                const formData3 = new FormData()
                formData3.append('header_id', data?.data?.header?.header_id)
                formData3.append('url', data_laravel?.file_path)

                const send_message = await fetch(url + 'update-header-pdf-url/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken,
                    },
                    body: formData3
                })

                if (send_message.ok == true) {
                    action()
                }

            }

        }
    }


    if (!user) {
        return window.location = window.location.origin + '/signInPage/'
    }

    function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    var csrftoken = getCookie('csrftoken');

    return (
        <section>
            {loading && <div id="loader"></div>}
            <PanelNav />
            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <div style={{ margin: '0 0.5%' }}>
                    <form onSubmit={e => handleSubmitOne(e)}>
                        <div className="container-fluid pl-0">
                            <div className="row border-manual py-2 px-2">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Select Client</label>
                                        <select className='form-control' value={currentParty} onChange={e => setCurrentParty(e.target.value)}>
                                            <option value="">Select Party Name</option>
                                            {allPartys.map(entry => <option key={entry.id} value={entry.id}>{entry.name}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Client Name</label>
                                        <p className="form-control">{partyName ? partyName : ''}</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Select Transporter</label>
                                        <select className='form-control' value={currentTransporter} onChange={e => setCurrentTransporter(e.target.value)}>
                                            <option value="">Select Transporter Name</option>
                                            {allTransporters.length > 0 && allTransporters.map(item => <option value={item.id}>{item.name}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Transporter Name</label>
                                        <p className="form-control">{transporterName}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row border-manual py-2 px-2">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">E way Bill No.</label>
                                        <input type="text" className="form-control" value={eWayBill} onChange={e => setEwayBill(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="">Order Through</label>
                                        <input type="text" className="form-control" value={orderThrough} onChange={e => setOrderThrough(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="">Loader</label>
                                        <select className='form-control' value={currentLoader} onChange={e => {
                                            if (e.target.value) {
                                                setDriverName(loaders.filter(item => item.id == e.target.value)[0]?.name)
                                                setDriverNumber(loaders.filter(item => item.id == e.target.value)[0]?.driver_number)
                                                setVehicleNo(loaders.filter(item => item.id == e.target.value)[0]?.vehicle_number)
                                                setCurrentLoader(e.target.value)
                                            }
                                        }}>
                                            <option value="">Select Loader</option>
                                            {loaders?.length > 0 && loaders.map((item, index) => (
                                                <option key={index} value={item?.id}>{item?.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Vehicle No.</label>
                                        <p className="form-control">
                                            {vehicleNo}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Driver Name</label>
                                        <p className="form-control">
                                            {driverName}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="">Driver No.</label>
                                        <p className="form-control">
                                            {driverNumber}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="">GRN No.</label>
                                        <input type="text" className="form-control" value={grn} onChange={e => setGrn(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="">Packed Date</label>
                                        <input type="date" className="form-control" value={packedBy} onChange={e => setPackedBy(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="">Used By</label>
                                        <input type="date" className="form-control" value={usedBy} onChange={e => setUsedBy(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="">Warranty</label>
                                        <input type="text" className="form-control" value={warranty} onChange={e => setWarranty(e.target.value)} />
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <button type="submit" className="btn-manual" disabled={currentHeaderId ? true : false}>
                                        {currentHeaderId ? 'Done' : 'Ok'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <form className="mid-form" onSubmit={e => handleSubmitTwo(e)}>
                        <div className="container-fluid pl-0">
                            <div className="row px-2 py-2">
                                <div className="col-md-4">
                                    <label htmlFor="">Item Name</label>
                                    <input list='item-list' autoComplete="off" className='form-control' value={currentItem} onChange={e => setCurrentItem(e.target.value)} />
                                </div>
                                <datalist id='item-list'>
                                    <option>Select Item</option>
                                    {allItem.length > 0 && allItem.map(item => <option>
                                        {`${item.id}-${item.name} ${item.category_code} ${item.inch}" ${item.gram}`}
                                    </option>)}
                                </datalist>
                                <div className="col-md-2">
                                    <label htmlFor="">HSN Code</label>
                                    <p className="form-control">{hsn ? hsn : ''}</p>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Boxes</label>
                                    <input type="text" className='form-control' value={boxes} onChange={e => setBoxes(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Weight/Box</label>
                                    <input type="text" className='form-control' value={weight} onChange={e => setWeight(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Rate/Kg</label>
                                    <input type="text" value={rateManual} className='form-control' onChange={e => setRateManual(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Total Wt.</label>
                                    <p className="form-control">{totalWeight}</p>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Item Cost Nettotal</label>
                                    <p className="form-control">{cost_company_nettotal}</p>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Total Cost Nettotal</label>
                                    <p className="form-control">{total_cost_company}</p>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Profit</label>
                                    <p className="form-control">{total_profit_item}</p>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Tax %.</label>
                                    <select value={tax} onChange={e => setTax(e.target.value)} className='form-control'>
                                        <option value="">-Gst-</option>
                                        {allGst.length > 0 && allGst.map((item, index) => {
                                            return <option value={item.name} key={index}>{item.name}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="">Total Amt.</label>
                                    <p className="form-control">{parseFloat(totalAmt).toFixed(2)}</p>
                                </div>
                                <div className="col-md-2 mt-4">
                                    <button className="btn-manual" id="mid-btn">
                                        Ok
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    {middleItem.length > 0 && <Table middleEntry={middleItem} deleteEntry={deleteEntry} />}
                    <div className="container-fluid pl-0 border-manual">
                        <div className="row-manual">
                            <div>
                                <p><span>Total boxes : {totalbox}</span></p>
                            </div>
                            <div>
                                <p><span>Total Weight :{parseFloat(totalWt).toFixed(2)} Kg</span></p>
                            </div>
                            <div>
                                <p><span>Gross Amount : {parseFloat(grossAmt).toFixed(2) - parseFloat(allTaxAmt).toFixed(2)} Rs</span></p>
                            </div>
                            <div>
                                <p><span>Tax Amount : {parseFloat(allTaxAmt).toFixed(2)} Rs</span></p>
                            </div>
                            <div>
                                <p><span>Total Cost : {parseFloat(totalCostCompany).toFixed(2)} Rs</span></p>
                            </div>
                            <div>
                                <p><span>Total Profit : {parseFloat(totalProfit).toFixed(2)} Rs</span></p>
                            </div>
                        </div>
                    </div>
                    <form onSubmit={e => handleSubmitThird(e)}>
                        <div className="container-fluid pl-0">
                            <div className="row border-manual">
                                <div className="col-md-6 mt-3" style={{ overflowY: 'scroll' }}>
                                    {pastPurchase.length > 0 && <div>
                                        <table>
                                            <thead style={{ background: 'green' }}>
                                                <th>#</th>
                                                <th>Product Name</th>
                                                <th>Rate</th>
                                            </thead>
                                            {pastPurchase.map((item, index) => {
                                                return <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item.name}</td>
                                                    <td>{parseFloat(item.rate).toFixed(2)} /-</td>
                                                </tr>
                                            })}
                                        </table>
                                    </div>}
                                </div>
                                <div className="col-md-6 final-form">
                                    <div className="check-box">
                                        <div className="form-group">
                                            <label htmlFor="">Bill Of Supply</label>
                                            <input type="checkbox" checked={billOfSupply} onClick={e => {
                                                setInterstate(false)
                                                setIntrastate(false)
                                                setBillOfSupply(e.target.checked)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="">Inter State</label>
                                            <input type="checkbox" checked={interstate} onClick={e => {
                                                setBillOfSupply(false)
                                                setIntrastate(false)
                                                setInterstate(e.target.checked)
                                            }} />

                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="">Intra State</label>
                                            <input type="checkbox" checked={intrastate} onClick={e => {
                                                setBillOfSupply(false)
                                                setInterstate(false)
                                                setIntrastate(e.target.checked)
                                            }} />

                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Total Amount : </label>
                                        <p className="form-control">{parseFloat(grossAmt).toFixed(2)}</p>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Discount In Rs : </label>
                                        <input type="text" className='form-control' value={discount} onChange={e => setDiscount(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Freight Charge : </label>
                                        <input type="text" className='form-control' value={frieghtCharge} onChange={e => setFrieghtCharge(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Final Amount</label>
                                        <p className="form-control">{parseFloat(finalAmount).toFixed(2)}</p>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Remarks</label>
                                        <input type="text" className='form-control' value={remarks} onChange={e => setRemarks(e.target.value)} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                        <button className="btn btn-success my-3" type="submit" style={{ width: '30%' }}>Save Bill</button>
                                        <button className="btn btn-success my-3" type="button" onClick={() => savePrint('bill')} style={{ width: '30%' }}>Print Bill</button>
                                        <button className="btn btn-success my-3" type="button" onClick={() => savePrint('challan')} style={{ width: '30%' }}>Print Challan</button>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </form>
                </div>
                <PanelSidebar />
            </div>

            <Footer />
        </section>
    )
}
